export const SOCIAL_LINKS = [
  {
    labelKey: 'footer.socialLinks.github',
    href: 'https://github.com/EchoingEkko00',
    icon: require('../assets/github.png'),
  },
  {
    labelKey: 'footer.socialLinks.instagram',
    href: 'https://www.instagram.com/lechrist666?igsh=MWd1Z3BwcWM0NHIydw==',
    icon: require('../assets/Instagram.png'),
  },
  {
    labelKey: 'footer.socialLinks.linkedin',
    href: 'https://www.linkedin.com/in/christopher-william-archambault-bouffard/',
    icon: require('../assets/linkedin.png'),
  },
  {
    labelKey: 'footer.socialLinks.facebook',
    href: 'https://www.facebook.com/JesusChrisDeNazareth/',
    icon: require('../assets/facebook.png'),
  },
];
